import Hotjar from './hotjar'

// We must send all analytics data (even for pixels) through the dataLayer, not to gtag/ga

// Guide for analytics
// https://paper.dropbox.com/doc/Analytics--A4hYqzb1AyntL6Du4GOSzXklAg-HKvXNDB2ms4WKDbzQ36QU
// TODO: rename to dataLayer or GTM, because we don't use ga directly
const GA = {
  storedUserId: null,

  get dataLayer() {
    if (!window.dataLayer) window.dataLayer = []
    return window.dataLayer
  },

  // Is gtm enabled (prod/dev env)
  get withGTM() {
    return Boolean(window.google_tag_manager)
  },

  // Send event to dataLayer
  push(data) {
    this.dataLayer.push(data)
    if (!this.withGTM) console.table(data) // eslint-disable-line
  },

  // Public method for send event
  send(params = {}) {
    // Use non verbose shortcut for common data
    const name = params.name || params.n
    const category = params.category || params.c
    const action = params.action || params.a
    const label = params.label || params.l
    const value = params.value || params.v

    const data = {}
    if (category) {
      data.event_category = category
    }
    if (action) {
      data.event_action = action
    }
    if (label) {
      data.event_label = label
    }
    if (value) {
      data.value = value
    }
    this.push({
      event: name,
      ...(category && { category }),
      ...(action && { action }),
      ...(label && { label }),
      ...(value && { value }),
    })
  },

  // FIXME: gtm have ability to track history changes, but we directly send a pageView event
  pageView(pagePath, pageTitle = document.title) {
    // NOTE: hot jar virtual page integration
    // https://help.hotjar.com/hc/en-us/articles/115011805448-Tracking-Virtual-Page-Views
    Hotjar.pageView(pagePath)

    // gtag('config', 'GA_MEASUREMENT_ID', {'page_path': '/new-page.html'});

    this.push({
      event: 'pageView',
      pagePath,
      pageTitle,
    })
  },

  // Need to move outside GA in common analytics
  userId(userId, isLogin = false) {
    if (!this.storedUserId) {
      this.storedUserId = userId
      this.push({
        event: 'User LoggedIn',
        category: 'login',
        // UserId could be set automatically by cookie initial login
        action: isLogin ? 'submitted' : 'auto',
        userId,
      })
    }
  },

  logout() {
    this.storedUserId = null
    this.push({
      event: 'User LoggedOut',
      userId: null,
    })
  },
}

export default GA
